'use client';

// Third Party Plugins
import React, { useState, useCallback, useEffect } from 'react';
// Types
import {
  ClientSidePastWinnersWrapperProps,
  PastScholarshipWinners,
} from '../../types';
// Custom Components
import SearchForm from '../SearchForm';
import PastScholarshipWinnersList from '../PastScholarshipWinnersList';
import ImageContainer from '@/components/images/ImageContainer';
import LayoutContainer from '@/components/ui/LayoutContainer';
import HeroHeading from '@/components/ui/HeroHeading';
import Gallery from '@/components/images/Gallery';
// import Pagination from '@components/shared/Pagination';

const ClientSidePastScholarshipWinnersWrapper: React.FC<
  ClientSidePastWinnersWrapperProps
> = ({
  headingOne,
  pageImageBlock,
  pastScholarshipWinners,
  hasGallery,
  galleryManyBlock,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredWinners, setFilteredWinners] = useState<
    PastScholarshipWinners[]
  >(pastScholarshipWinners);
  // const [showPagination, setShowPagination] = useState(true);

  const searchWinners = useCallback(() => {
    if (!searchTerm.trim()) {
      setFilteredWinners(pastScholarshipWinners);
      // setShowPagination(true);
      return;
    }
    const items = pastScholarshipWinners.filter((winner) =>
      winner.pastWinnerTitle
        .trim()
        .toLowerCase()
        .includes(searchTerm.trim().toLowerCase()),
    );
    setFilteredWinners(items || []);
    // setShowPagination(false);
  }, [searchTerm, pastScholarshipWinners]);

  useEffect(() => {
    searchWinners();
  }, [searchTerm, searchWinners]);

  return (
    <>
      <HeroHeading>
        <h1>{headingOne}</h1>
        {pageImageBlock ? (
          <ImageContainer
            image={pageImageBlock.asset.url}
            width={751}
            height={194}
            type="dynamic"
            alt={pageImageBlock.alt || ''}
          />
        ) : null}
        <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      </HeroHeading>
      <LayoutContainer hasSectionGaps>
        <PastScholarshipWinnersList winners={filteredWinners} />
        {/* {showPagination && ( */}
        {/*   <Pagination */}
        {/*     pageSize={10} */}
        {/*     totalCount={pastWinners.length} */}
        {/*     currentPage={1} */}
        {/*     skip={0} */}
        {/*     base="/past-winners" */}
        {/*     visible={true} */}
        {/*   /> */}
        {/* )} */}
        {hasGallery && galleryManyBlock ? (
          <Gallery
            images={galleryManyBlock.map((image) => ({
              alt: image.alt || '',
              url: image.asset.url, // Move the URL to the top level
              asset: image.asset,
              crop: image.crop,
              hotspot: image.hotspot,
            }))}
          />
        ) : null}
      </LayoutContainer>
    </>
  );
};

export default ClientSidePastScholarshipWinnersWrapper;
